/*
 * @Author: liuhuazhou liuhuazhou@xiaomi.com
 * @Date: 2024-08-19 10:02:18
 * @LastEditors: liuhuazhou liuhuazhou@xiaomi.com
 * @LastEditTime: 2024-08-19 11:21:47
 * @FilePath: /RetailApp/retail-global-h5/src/pages/RetailGlobal/Protocol/PrivacyNotice/id-ID/index.tsx
 * @Description: 这是默认设置，请设置 `customMade`, 打开 koroFileHeader 查看配置 进行设置：https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { memo, useEffect } from 'react';
import globalStyles from '../../../global.less';
import styles from './index.less';

var HTML_CONTENT = ""
HTML_CONTENT += `
    <html>
        <body>
            <div>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">To help our payment gateway provider create your unique purchase order, and to help our installment provider review your credit for it, we will collect <b>your name and email address</b> and share it with the providers.</span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">The legal basis for these activities of processing your personal data is their <b>necessity for performing a contract to which you are a party</b>.</span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">Please consult our store staff should you have any questions about how we process your personal data, and about how you may exercise your data protection rights (e.g. access, rectification and/or erasure). Xiaomi's Privacy Policy is available at <a href="https://privacy.mi.com/all/languages" style="text-decoration:none; color:#3370ff;">https://privacy.mi.com/all/languages</a>.</span>
                </p>
            </div>
        </body>
    </html>`;

    
function AuthPage() {

    useEffect(() => {
    }, []);

    // 一个用于渲染 html 的函数组件
    const renderHtml = (html: string) => {
        return <div dangerouslySetInnerHTML={{ __html: html }} />;
    };

    return (
        <div className={[globalStyles['container'], styles['viewport']].join(' ')}>
            {renderHtml(HTML_CONTENT)}
        </div>
    )
}

export default memo(AuthPage)
